import Header from "./header";
import Banner from "./banner";
import Footer from "./footer";
import CompanySlider from "./Slider";
import Sas from "./SAS";
import ProductCards from "./ProductsCards";
import PopUp from "./pop_up";


function Home() {
    return (
        <div className="App">
            <Header />
            {/* Üst container */}
            <div className="upper-container">
                <Banner />
            </div>

            {/* Pop-up */}
            <div style={{ position: "relative" }}>
                <PopUp />
            </div>

            {/* Alt container */}
            <div className="lower-container">
                <ProductCards />
            </div>

            <Sas />
            <CompanySlider />
            <Footer />
        </div>
    );
}

export default Home;